$(function () {



    $('[data-toggle]').on('click', function () {
        let toggle_name = $(this).data('toggle');
        let target_name = $(this).data('target');
        let target_element = $(
            '[data-toggle="showbox"][data-target="' + target_name + '"]'
        );

        if (toggle_name == 'openbox') {
            let target_status = target_element.data('status');
            $(
                '[data-toggle="showbox"]:not([data-target="' + target_name + '"])'
            ).attr('data-status', false);

            if (target_status == false) {
                target_element.attr('data-status', true);
            } else {
                target_element.attr('data-status', false);
            }
        } else if (toggle_name == 'closebox') {
            target_element.attr('data-status', false);
        }
    });

    $(document).on('click', function () {
        $('[data-toggle="showbox"]').attr('data-status', false);
    });

    $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
            $('[data-toggle="showbox"]').attr('data-status', false);
        }
    });

    $('[data-toggle="showbox"],[data-toggle="openbox"]').click(function (event) {
        event.stopPropagation();
    });

    $('.mobile-menu nav ul li').on('click', function () {
        $('ul', this).toggleClass('open-list');
    })





    var Swiper1 = new Swiper('.post-slider-new', {
        slidesPerView: 1,
        spaceBetween: 50,
        navigation: {
            nextEl: '.post-slider-new__next',
            prevEl: '.post-slider-new__prev',
        },
        loop: 1,
        pagination: {
            el: '.main-swiper__pagination-post-slide',
            type: 'bullets',
            clickable: true,
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0,

        },

    });



    $('a[href="#"]').click(function (e) {
        e.preventDefault();
    });

    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function (event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 70
                    }, 1000, function () {
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) {
                            return false;
                        } else {
                            $target.attr('tabindex', '-1');
                            $target.focus();
                        };
                    });
                }
            }
        });


    $('[data-toggle]').on('click', function () {
        let toggle_name = $(this).data('toggle');
        let target_name = $(this).data('target');
        let target_element = $('[data-toggle="showbox"][data-target="' + target_name + '"]');

        if (toggle_name == 'openbox') {
            let target_status = target_element.data('status');
            $('[data-toggle="showbox"]:not([data-target="' + target_name + '"])').attr('data-status', false);

            if (target_status == false) {
                target_element.attr('data-status', true);
            }
            else {
                target_element.attr('data-status', false);
            }
        }
        else if (toggle_name == 'closebox') {
            target_element.attr('data-status', false);
        }
    });

    $(document).on('click', function () {
        $('[data-toggle="showbox"]').attr('data-status', false);
    });

    $(document).on('keyup', function (e) {
        if (e.key === "Escape") {
            $('[data-toggle="showbox"]').attr('data-status', false);
        }
    });

    $('[data-toggle="showbox"],[data-toggle="openbox"]').click(function (event) {
        event.stopPropagation();
    });



    // Tabs
    //=====================================================================

    $(document).on('click', 'li[data-tab]', function () {
        let $this = $(this),
            tab = $this.data('tab'),
            target = $this.data('tab-target');

        $this.addClass('active')
            .siblings()
            .removeClass('active');

        $('.tab-content[data-tab-target="' + target + '"][data-tab="' + tab + '"]')
            .addClass('active')
            .siblings()
            .removeClass('active');
    });


    $(document).on('mouseover', 'li[data-tab-hover]', function () {
        let $this = $(this),
            tab = $this.data('tab-hover'),
            target = $this.data('tab-target');

        $this.addClass('active')
            .siblings()
            .removeClass('active');

        $('.tab-content[data-tab-target="' + target + '"][data-tab="' + tab + '"]')
            .addClass('active')
            .siblings()
            .removeClass('active');
    });


    // Toaster Alert
    //=====================================================================

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });


    $(window).scroll(() => {
        var scroll = $(window).scrollTop();
        if (scroll > 100) {
            $('body').addClass('body--header-fix')
        }
        else {
            $('body').removeClass('body--header-fix')
        }
    });


    $(document).ready(function () {
        $(".main-header__nav ul li ").hover(function () {
            $('>div', this).css("display", "block");

        }, function () {
            $('>div', this).css("display", "none");

        });


        //     // $("#Modal").modal('show');
    });


    $(document).ready(function () {
        $(".main-header__nav__mega-menu ul  >li").hover(function () {

            $('>ul', this).css("display", "block");

        },function (){
            $('>ul', this).css("display", "none");
        });



        $('.main-header__nav ul >li').on('click', function () {
            $(this).toggleClass('active')
        })

        
        $('.main-header__nav__mega-menu ul >li').on('click', function () {
            $(this).toggleClass('active')
        })
    });




     

    var product_slider = new Swiper('.product-slider .swiper-container', {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: 1,
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
        },
        autoplay: {
            delay: 3000,
            disableOnInteraction: 0
        },

        breakpoints: {

            992: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            576: {
                slidesPerView: 2,
                spaceBetween: 30,

            },

            440: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            320: {
                slidesPerView: 1,
                spaceBetween: 30,
            },



        }
    });

    var company_slider = new Swiper('.company-slider .swiper-container', {
        slidesPerView: 6,
        spaceBetween: 30,
        loop: 1,
        navigation: {
            nextEl: '.swiper-btn-next',
            prevEl: '.swiper-btn-prev',
        },
        autoplay: {
            delay: 4000,
            disableOnInteraction: 0
        },
    });

    // Produc Thumb Slider
    //=====================================================================

    var detail_image_thumb = new Swiper('.product-single__image__thumb-slider .swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlide: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    })

    // Produc Image Slider
    //=====================================================================

    var detail_image = new Swiper('.product-single__image__main-slider .swiper-container', {
        simulateTouch: false,
        thumbs: {
            swiper: detail_image_thumb
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    })

    // Produc Image Zoom
    //=====================================================================

    $('.zoom').zoom();

    // Gets background-color code from HTML and set --> Ex: data-bgcolor="#aaa222"
    //=====================================================================

    $('[data-bgcolor]').each(function (i, e) {
        $(e).css('background-color', $(e).data('bgcolor'))
    })


    // Gets color code from HTML and set --> Ex: data-color="#fff"
    //=====================================================================

    $('[data-color]').each(function (i, e) {
        $(e).css('color', $(e).data('color'))
    })

    var product_rate = $('.product-single__review__number').data('rate');

    $('.product-single__review__inner label').on('mouseenter', function () {
        var rate = $(this).data('rate');
        $('.product-single__review__number').html(rate);
    })

    $('.product-single__review__inner').on('mouseleave', function () {
        $('.product-single__review__number').html(product_rate);
    })

    $('.product-single__review__inner label').on('click', function () {
        let $this = $(this);
        let parent = $(this).closest('.product-single__review');
        let data = {};
        data['rate'] = rate = $this.data('rate');
        data['postid'] = parent.data('postid');
        data['nonce'] = parent.data('nonce');
        data['action'] = 'product_rating';
        $('.product-single__review__number').html(rate).attr('data-rate', rate);

        Toast.fire({
            icon: 'success',
            title: 'با موفقیت انجام شد',
            footer: data.message,
        });



        // $.ajax({
        //     type: 'POST',
        //     dataType: 'json',
        //     url: global_object.ajax_url,
        //     data: data,
        //     success: function (data) {
        //         console.log(data);
        //         if (data.status == 1) {
        //             Toast.fire({
        //                 icon: 'success',
        //                 title: 'با موفقیت انجام شد',
        //                 footer: data.message,
        //             });
        //         } else {
        //             Toast.fire({
        //                 icon: 'error',
        //                 title: 'متاسفانه انجام نشد',
        //                 footer: data.message,
        //             });
        //         }
        //     },
        //     error: function (data) {
        //         console.log(data);
        //         Toast.fire({
        //             icon: 'error',
        //             title: 'متاسفانه انجام نشد',
        //             footer: 'در ارسال درخواست مشکلی وجود دارد.',
        //         });
        //     }
        // });
    })



    $('.product-single__buy__qty i').on('click', function () {
        let el = $(this);
        let type = el.data('type');
        let span = el.siblings('span');
        let input = el.siblings('input');
        let val = parseInt(span.data('value'));
        let max = parseInt(span.data('max'));
        let min = parseInt(span.data('min'));
        if (type == 'plus' && val < max) {
            input.val(val + 1);
            span.text(val + 1).data('value', val + 1);
        }
        else if (type == 'minus' && val > min) {
            input.val(val - 1);
            span.text(val - 1).data('value', val - 1);
        }
    });

    $('.profile__sidebar nav li').has('>ul').addClass('has-child').prepend('<i class="dn-arrow-down"></i>');

    $('.profile__sidebar nav li.has-child >a').on('click', function () {

        let $this = $(this).parent();
        let $child = $(this).siblings('ul');
        if ($this.hasClass('active')) {
            $child.slideUp(200, function () {
                $this.removeClass('active');
            });
        }
        else {
            $child.slideDown(200, function () {
                $this.addClass('active');
            });
        }

    });


    $('.profile__header__toggle').on('click', function () {

        $('.profile__wrapper').toggleClass('profile__wrapper--collapse');

    });

    $(".datepicker").persianDatepicker({
        observer: true,
        format: 'YYYY/MM/DD',
        autoClose: true
    });


    $(document).on('click', '.profile__content__dropdown__title', function () {
        var $this = $(this);
        var $parent = $this.parent();
        var $content = $this.siblings('.profile__content__dropdown__content');
        var status = $parent.attr('data-open');
        console.log(status)
        if (status == 'true') {
            $content.slideUp(500, function () {
                $parent.attr('data-open', 'false')
            });
        }
        else if (status == 'false') {
            $content.slideDown(500, function () {
                $parent.attr('data-open', 'true')
            });
        }
    })

    $(document).on('click', '.product-cat__filter__item__title', function () {

        var $this = $(this);
        var $item = $this.closest('.product-cat__filter__item');
        var $content = $this.siblings('.product-cat__filter__item__content');

        if ($item.hasClass('product-cat__filter__item--active')) {

            $content.slideUp(150, function () {
                $item.removeClass('product-cat__filter__item--active')
            })
        }
        else {
            $content.slideDown(150, function () {
                $item.addClass('product-cat__filter__item--active')
            })
        }
    });



    $('.product-cat__filter__item__title').append('<i class="dn-arrow-down"></i>');

    $('.product-cat__filter__item__title').on('click', function () {
        var $this = $(this);
        var $item = $this.closest('.product-cat__filter__item');

        var is_open = $item.hasClass('product-cat__filter__item--active');

        if (is_open) {
            $item.find('.product-cat__filter__item__content').slideUp(200, function () {
                $item.removeClass('product-cat__filter__item--active')
            });
        }
        else {
            $item.find('.product-cat__filter__item__content').slideDown(200, function () {
                $item.addClass('product-cat__filter__item--active')
            });
        }
    })


    $(document).on('click', '.load_more', function () {
        var $options_list = $(this).closest('.product-cat__filter__item__content--load-more');
        if ($options_list.hasClass('product-cat__filter__item__content--items_show')) {
            $options_list.removeClass('product-cat__filter__item__content--items_show');
            $('span', this).html('نمایش بیشتر');
        }
        else {
            $options_list.addClass('product-cat__filter__item__content--items_show');
            $('span', this).html('نمایش کمتر');
        }
    });

    $('.product-cat__filter__item__content__search input').on('keyup', function () {
        var val = $(this).val();
        $(this).closest('.product-cat__filter__item__content').find('label').each(function () {
            if ($(this).text().search(val) > -1) {
                $(this).parent().removeClass('not_result');
            }
            else {
                $(this).parent().addClass('not_result');
            }
        });
    });



    $(".auth__btns a").on("click", function () {
        var $this = $(this);
        $('.auth__form--form').hide();
        $('.auth__form--code').show();

        var t = new Date($.now());
        t.setSeconds(t.getSeconds() + 5);
        var $timer = $('.auth__form__actions span span');
        $('.auth__form__actions').addClass('auth__form__actions--timer');


        $timer.countdown(t)
            .on('update.countdown', function (event) {
                $timer.html(event.strftime('%-M:%S'));
            })
            .on('finish.countdown', function (event) {
                $('.auth__form__actions').removeClass('auth__form__actions--timer');
            });
    });


    $('.auth__form__actions a').on("click", function () {
        var t = new Date($.now());
        t.setSeconds(t.getSeconds() + 5);
        var $timer = $('.auth__form__actions span span');
        $('.auth__form__actions').addClass('auth__form__actions--timer');
        $timer.countdown(t)
            .on('update.countdown', function (event) {
                $timer.html(event.strftime('%-M:%S'));
            })
            .on('finish.countdown', function (event) {
                $('.auth__form__actions').removeClass('auth__form__actions--timer');
            });
    });

    $('.auth__form__header a').on("click", function () {
        $('.auth__form--form').show();
        $('.auth__form--code').hide();
    });


    $('.auth__form__dashed input').on('keypress', function () {
        var number = $(this).val();
        if (number.length >= 5) {
            $(this).val(number.slice(0, 5));
            return false;
        }
    });



    $('.quantity').each(function () {

        var qty = $(this),
            input = qty.find('input'),
            plus = qty.find('i[data-type="plus"]'),
            minus = qty.find('i[data-type="minus"]'),
            min = input.attr('min'),
            max = input.attr('max'),
            number = qty.find('span b')

        plus.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue >= max) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue + 1;
            }
            input.val(newVal);
            input.trigger("change");
            number.html(newVal)
        });

        minus.click(function () {
            var oldValue = parseFloat(input.val());
            if (oldValue <= min) {
                var newVal = oldValue;
            } else {
                var newVal = oldValue - 1;
            }
            input.val(newVal);
            input.trigger("change");
            number.html(newVal)
        });
    })
    $('a.share').on("click",function(e){
        e.preventDefault();
        $(this).siblings('ul').slideToggle(300)
    })
    $('a.favorite').on("click",function(e){
        e.preventDefault();
        if($(this).hasClass('active'))
        {
            $(this).removeClass('active')

        }
        else
        {
            $(this).addClass('active')
        }
    })


    // Toast.fire({
    //     icon: 'success',
    //     title: 'توستر',
    //     footer: 'این تست توستر است',
    // });


    //=============================//
    // r.dadkhah.tehrani@gmail.com //
    //=============================//
});
